module.exports = __webpack_public_path__ + "img/proapp-2.db9dd706.jpg";